export default __webpack_public_path__ + "static/media/icp-interview.f3af92ee.jpg";